import { render } from "./CountriesProvidersImport.vue?vue&type=template&id=bccf3c52"
import script from "./CountriesProvidersImport.vue?vue&type=script&lang=js"
export * from "./CountriesProvidersImport.vue?vue&type=script&lang=js"

import "./CountriesProvidersImport.vue?vue&type=style&index=0&id=bccf3c52&lang=scss"

import exportComponent from "/usr/src/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__